import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-dynamic-title',
  templateUrl: './dynamic-title.component.html',
  styleUrls: ['./dynamic-title.component.sass'],
})
export class DynamicTitleComponent {
  @Input() icon!: string;
  @Input() title!: string;
  @Input() subtitle!: string;
  constructor() {}
}
